import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";

import Text from "../../components/Text";
import cardImage1 from "../../assets/images/card-1.jpg";
import cardImage2 from "../../assets/images/card-2.jpg";
import cardImage3 from "../../assets/images/card-3.jpg";

const cards = [cardImage1, cardImage2, cardImage3];

const MainCardsSection = () => {
  const handleHover = (event) => {
    event.stopPropagation();
  };

  return (
    <div>
      <div className="cards-container w-full">
        {/* <!-- Slider main container --> */}
        <Swiper
          modules={[Autoplay]}
          className="pt-3"
          spaceBetween={10}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            360: {
              slidesPerView: 1.5,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {cards.map((card, index) => {
            return (
              <SwiperSlide className="px-4" key={index}>
                <div
                  className=" card"
                  onMouseMove={(event) => handleHover(event)}
                >
                  <div className="card-bg group relative">
                    <div
                      className="img  absolute top-0 w-full h-full bg-cover bg-center rounded transition-all duration-500 group-hover:scale-[102%]"
                      style={{ backgroundImage: `url(${card})` }}
                    ></div>
                    <div className="flex items-center justify-center w-full xs:px-3 lg:px-5 py-6 text-white text-center xs:text-[19px] md:text-2xl xs:font-normal lg:font-semibold drop-shadow-xl">
                      <h2 className="xs:py-5 sm:py-11 xs:max-w-[110px] md:max-w-none">
                        Healthy Store
                      </h2>
                    </div>
                  </div>

                  <div className="card-caption mt-4">
                    <Text
                      text={
                        "Explore +1000 professional nutritionists from all over Turkey"
                      }
                      component="p"
                      classes={"text-secondary-700 text-center text-[15px]"}
                    />
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default MainCardsSection;
